var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-toasts"},_vm._l((_vm.$store.state.ui.toasts),function(toast){return _c('Toast',{key:toast.index,attrs:{"toast":toast}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }